import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/", label: "Strona główna" },
  { to: "/warsztaty", label: "Warsztaty" },
  { to: "/dostep", label: "Dostęp do pracowni" },
  { to: "/o-nas", label: "O nas" },
  { to: "/regulamin", label: "Regulamin" },
  { to: "/kontakt", label: "Kontakt" },
  { to: "/wejscie", label: "Wejście", highlight: true },
];

export default function Navbar() {
  const [open, setOpen] = React.useState(false);

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 bg-[#1F1F1F]/90 backdrop-blur-md border-b border-[#3a3a3a]"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 h-[88px] flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link" className="flex items-center">
          <img
            src="/logo.png"
            alt="Śląski Maker Space"
            className="h-14 md:h-16 w-auto"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={`nav-link-${n.to.replace("/", "") || "home"}`}
              className={({ isActive }) => {
                if (n.highlight) {
                  return `font-display text-xs uppercase ml-2 px-5 py-3 transition-all ${
                    isActive ? "bg-white text-[#2A2A2A]" : "bg-[#FFCC00] text-[#2A2A2A] hover:bg-white"
                  }`;
                }
                return `font-mono-acc text-sm uppercase px-4 py-2 transition-colors ${
                  isActive ? "text-[#FFCC00]" : "text-white/70 hover:text-white"
                }`;
              }}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <button
          className="lg:hidden text-white"
          onClick={() => setOpen((s) => !s)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#3a3a3a] bg-[#1F1F1F]" data-testid="mobile-menu">
          <div className="flex flex-col">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.to.replace("/", "") || "home"}`}
                className={({ isActive }) => {
                  if (n.highlight) {
                    return `px-6 py-4 font-display text-xs uppercase border-b border-[#2f2f2f] transition-colors ${
                      isActive ? "bg-white text-[#2A2A2A]" : "bg-[#FFCC00] text-[#2A2A2A]"
                    }`;
                  }
                  return `px-6 py-4 font-mono-acc text-sm uppercase border-b border-[#2f2f2f] ${
                    isActive ? "text-[#FFCC00]" : "text-white/80"
                  }`;
                }}
              >
                {n.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
